export default __webpack_public_path__ + "static/media/collapse.51da5ead.svg";